import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { UserProfile } from './types';

export const getUserProfile = async (userId: string): Promise<UserProfile | null> => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) return null;
    
    const data = userDoc.data();
    return {
      uid: userId,
      email: data.email,
      displayName: data.displayName,
      photoURL: data.photoURL,
      emailVerified: data.emailVerified,
      metadata: data.metadata || {}
    };
  } catch (error) {
    console.error('Error getting user profile:', error);
    return null;
  }
};

export const updateUserProfile = async (userId: string, updates: Partial<UserProfile>): Promise<void> => {
  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    // Si une mise à jour de photoURL est demandée, on vérifie qu'elle est différente
    if (updates.photoURL !== undefined) {
      const currentData = userDoc.data();
      // Ne mettre à jour que si la nouvelle URL est différente ou si c'est null
      if (updates.photoURL === currentData?.photoURL) {
        delete updates.photoURL;
      }
    }

    if (Object.keys(updates).length > 0) {
      await setDoc(userRef, {
        ...updates,
        updatedAt: new Date().toISOString()
      }, { merge: true });

      // Mettre à jour le localStorage uniquement si des modifications ont été effectuées
      const localData = localStorage.getItem('userData');
      if (localData) {
        const currentData = JSON.parse(localData);
        const updatedData = {
          ...currentData,
          ...updates,
        };
        localStorage.setItem('userData', JSON.stringify(updatedData));
      }
    }
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};